import React, { useState, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { helper } from '../common/helper.js';
import Select from "react-dropdown-select";
import styled from "styled-components";
import { sceneCardActions } from '../../actions/scene/sceneCardActions.js';
import '../App.css';
import SpinnerLoad from './spinner.js';
import MovieIcon from '@mui/icons-material/Movie';
import PersonIcon from '@mui/icons-material/Person';
import TuneIcon from '@mui/icons-material/Tune';

function FilterScene(props) {

    const history = useHistory();
    const [direc, setDirec] = useState(props.params.direction);

  const safeArray = (arr) => (Array.isArray(arr) ? arr.filter(Boolean) : []);
  const safeSingleValue = (value) => (value ? [value] : []);

    const url = (key, item) => {
        if (key === "sort")
            return `${props.baseUrl}&sort=${item}&direction=${direc}`;
        if (key === "direction")
            return `${props.baseUrl}&sort=${props.params.sort}&direction=${item.key}`;
    }

    const paramURL = (site, model, tag, movie, studio, company, direction, modelsort, sexe, status, positionCount) => {
        return `/scenes?site=${site}&movie=${movie}&studio=${studio}&company=${company}${modelsort!=null?`&modelsort=${modelsort}`:""}${sexe!=null?`&sexe=${sexe}`:""}${status!=null?`&status=${status}`:""}${model}${tag}&size=${props.params.size}&sort=${props.params.sort}&direction=${direction == null ? props.params.direction : direction}&dateReleased=${props.params.dateReleased}&search=${props.scenes.search}&positionCount=${props.params.positionCount}`;
    }

    const openFilterFunc = () => {
        if (props.openFilter === false)
            props.setOpenFilter(true);
        else
            props.setOpenFilter(false);
    }

    const onSearch = () => {
        history.push(paramURL(props.params.site, helper.query(props.params.model, "model"), helper.query(props.params.tag, "tag"), props.params.movie, props.params.studio, props.params.company, props.params.direction, props.params.modelsort, props.params.sexe, props.params.status, props.params.positionCount));
    }

    const sceneRefresh = (value) => {
        onSearch();
        props.sceneRefresh(value);
    }

    const directionChange = (key, item) => {
        if (direc == 'asc') {
            setDirec('desc')
        }
        else {
            setDirec('asc')
        }
        props.filterRefresh(key, item, direc)
    }

    const itemRenderer = ({ item, itemIndex, props, state, methods }) => (
        <div style={{backgroundColor:`${methods.isSelected(item)?'black':'white'}`, color:`${methods.isSelected(item)?'white':'black'}` }} key={item[props.valueField]} onClick={() => methods.addItem(item)}>
          <div style={{ margin: "4px"}}>
          {item.tagType =='Scene'?<MovieIcon/>:<PersonIcon/>}
            &nbsp;&nbsp;&nbsp;{item[props.labelField]}
            
          </div>
        </div>
      );
    
    useEffect(() => {
        if (direc == 'asc') {
            setDirec('desc')
        }
        else {
            setDirec('asc')
        }
    }, [])

    return (<div style={{ padding: '16px 12px' }}>
        <FilterHeader>
            <SearchContainer>
                <SearchInput 
                    placeholder="Search scenes..." 
                    value={props.scenes.search} 
                    onChange={(e) => {
                        props.setSceneFilter('SEARCH', e.target.value);
                        onSearch();
                    }} 
                    onKeyDown={(e) => e.key === "Enter" ? sceneRefresh(e.target.value) : ""} 
                />
                <ModernButton onClick={(e) => sceneRefresh(props.scenes.search)}>Search</ModernButton>
            </SearchContainer>
            <FilterButtonContainer>
                {!props.fetching.filter && !props.fetching.scene && !props.fetching.count ?
                    <FilterToggleButton onClick={openFilterFunc} isOpen={props.openFilter}>
                        <TuneIcon fontSize="small" />
                        Filters
                    </FilterToggleButton>
                    :<SpinnerLoad/>
                }
            </FilterButtonContainer>
        </FilterHeader>

        {props.openFilter && !props.fetching.filter && !props.fetching.scene && !props.fetching.count ?
            <FilterPanel>
                <FilterGrid>
                    {!props.isFetching ?
                        <FilterGroup>
                            <FilterLabel>Studio</FilterLabel>
                            <StyledSelect 
                              options={safeArray(props.studio.available)} 
                                placeholder="Select Studio" 
                                labelField="nameScene" 
                                valueField="id"
                                color="#000000" 
                                searchable="true" 
                                clearable="true" 
                                searchBy="name" 
                                sortBy="name" 
                                dropdownHeight="450px" 
                                dropdownPosition="auto"
                                values={safeSingleValue(props.studio.selected)}
                                onChange={(e) => {
                                    if (Array.isArray(e)) {
                                        if (e.length > 0) {
                                            history.push(paramURL(props.params.site, helper.query(props.params.model, "model"), helper.query(props.params.tag, "tag"), props.params.movie, e[0].id, props.params.company ));
                                        }
                                        else {
                                            history.push(paramURL(props.params.site, helper.query(props.params.model, "model"), helper.query(props.params.tag, "tag"), props.params.movie, -1, props.params.company))
                                            props.studioRefresh("-1")
                                        }
                                    }
                                }}
                            />
                        </FilterGroup> 
                        : <FilterGroup><Spinner animation="border" variant="danger" size="bg" /></FilterGroup>}

                    {!props.isFetching ?
                        <FilterGroup>
                            <FilterLabel>Sites</FilterLabel>
                            <StyledSelect 
                              options={safeArray(props.sites.available)} 
                                placeholder="Select Site" 
                                labelField="nameScene" 
                                valueField="siteId"
                                color="#000000" 
                                searchable="true" 
                                clearable="true" 
                                searchBy="name" 
                                sortBy="name" 
                                dropdownHeight="450px" 
                                dropdownPosition="auto"
                                values={safeSingleValue(props.sites.selected)}
                                onChange={(e) => {
                                    if (Array.isArray(e)) {
                                        if (e.length > 0) {
                                            history.push(paramURL(e[0].siteId, helper.query(props.params.model, "model"), helper.query(props.params.tag, "tag"), props.params.movie, props.params.studio, props.params.company, props.params.direction, props.params.modelsort, props.params.sexe, props.params.status));
                                        }
                                        else {
                                            history.push(paramURL(-1, helper.query(props.params.model, "model"), helper.query(props.params.tag, "tag"), props.params.movie, props.params.studio, props.params.company, props.params.direction, props.params.modelsort, props.params.sexe, props.params.status));
                                            props.site("-1")
                                        }
                                    }
                                }}
                            />
                        </FilterGroup> 
                        : <FilterGroup><Spinner animation="border" variant="danger" size="bg" /></FilterGroup>}

                    {!props.isFetching ?
                        <FilterGroup>
                            <FilterLabel>Movies</FilterLabel>
                            <StyledSelect 
                              options={safeArray(props.movies.available)} 
                                placeholder="Select Movie" 
                                labelField="name" 
                                valueField="id"
                                color="#000000" 
                                searchable="true" 
                                clearable="true" 
                                searchBy="name" 
                                sortBy="name" 
                                dropdownHeight="450px" 
                                dropdownPosition="auto"
                                values={safeSingleValue(props.movies.selected)}
                                onChange={(e) => {
                                    if (Array.isArray(e)) {
                                        if (e.length > 0) {
                                            history.push(paramURL(props.params.site, helper.query(props.params.model, "model"), helper.query(props.params.tag, "tag"), e[0].id, props.params.studio, props.params.company, props.params.direction, props.params.modelsort, props.params.sexe, props.params.status));
                                        }
                                        else {
                                            history.push(paramURL(props.params.site, helper.query(props.params.model, "model"), helper.query(props.params.tag, "tag"), -1, props.params.studio, props.params.company, props.params.direction, props.params.modelsort, props.params.sexe, props.params.status))
                                            props.movie("-1")
                                        }
                                    }
                                }}
                            />
                        </FilterGroup> 
                        : <FilterGroup><Spinner animation="border" variant="danger" size="bg" /></FilterGroup>}

                    {!props.isFetching ?
                        <FilterGroup>
                            <FilterLabel>Models</FilterLabel>
                            <StyledSelect 
                                multi 
                              options={safeArray(props.models.available)} 
                              values={safeArray(props.models.selected)}
                                placeholder="Select a model..." 
                                labelField="nameScene" 
                                valueField="id"
                                color="#333" 
                                searchable="true" 
                                clearable="true" 
                                searchBy="name"
                                dropdownHandleRenderer={({ state }) => (<span>{state.dropdown ? '–' : '+'}</span>)}
                                onChange={(e) => {
                                    var temp = e.map(a => a.id).sort();
                                    history.push(paramURL(props.params.site, helper.query(temp, "model"), helper.query(props.params.tag, "tag"), props.params.movie, props.params.studio, props.params.company, props.params.direction, props.params.modelsort, props.params.sexe, props.params.status));
                                }} 
                            />
                        </FilterGroup> 
                        : <FilterGroup><Spinner animation="border" variant="danger" size="bg" /></FilterGroup>}

                    {!props.isFetching ?
                        <FilterGroup>
                            <FilterLabel>Tags</FilterLabel>
                            <StyledSelect 
                                multi 
                              options={safeArray(props.tags.available)} 
                              values={safeArray(props.tags.selected)}
                                placeholder="Select a tag..." 
                                labelField="name" 
                                valueField="id"
                                color="#333" 
                                searchable="true" 
                                clearable="true" 
                                searchBy="fullName"
                                dropdownHandleRenderer={({ state }) => (<span>{state.dropdown ? '–' : '+'}</span>)}
                                itemRenderer={(item, itemIndex, props, state, methods) => itemRenderer(item, itemIndex, props, state, methods)}
                                onChange={(e) => {
                                    var temp = e.map(a => a.id);
                                    history.push(paramURL(props.params.site, helper.query(props.params.model, "model"), helper.query(temp, "tag"), props.params.movie, props.params.studio, props.params.company, props.params.direction, props.params.modelsort, props.params.sexe, props.params.status));
                                }} 
                            />
                        </FilterGroup> 
                        : <FilterGroup><Spinner animation="border" variant="danger" size="bg" /></FilterGroup>}
                </FilterGrid>
            </FilterPanel> 
            : <></>}
    </div>
    );
}

const FilterHeader = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: center;
`;

const SearchContainer = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 10px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background-color: #ffffff;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: #999;
  }
`;

const ModernButton = styled.button`
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
  }

  &:active {
    transform: translateY(0px);
  }
`;

const FilterButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const FilterToggleButton = styled.button`
  padding: 10px 16px;
  border: 2px solid #667eea;
  border-radius: 8px;
  background: ${props => props.isOpen ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#ffffff'};
  color: ${props => props.isOpen ? '#ffffff' : '#667eea'};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(102, 126, 234, 0.2);
  }
`;

const FilterPanel = styled.div`
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8eef5;
`;

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
`;

const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const FilterLabel = styled.label`
  font-weight: 600;
  color: #333;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const StyledSelect = styled(Select)`
  .react-dropdown-select {
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    background-color: #ffffff;
    transition: all 0.3s ease;
    padding: 6px 8px;
    min-height: auto;

    &:focus-within {
      border-color: #667eea;
      box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .react-dropdown-select-input {
      font-size: 13px;
      color: #333;
      padding: 6px 0;
      min-height: 24px;
    }

    /* Selected item chips */
    .react-dropdown-select-item {
      margin: 3px 6px 3px 0;
      border-radius: 6px;
      padding: 6px 10px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      font-weight: 500;
      font-size: 12px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      white-space: nowrap;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  /* Dropdown menu */
  .react-dropdown-select-dropdown {
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
    background: #ffffff;
    margin-top: 8px;
    max-height: 450px;
    overflow-y: auto;
    z-index: 1000;

    /* Custom scrollbar */
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 8px;
    }
  }

  /* Dropdown item options */
  .react-dropdown-select-dropdown-item {
    padding: 12px 14px;
    background-color: #f8f9fb;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      transform: scaleY(0);
      transition: transform 0.2s ease;
    }

    &:hover {
      background: linear-gradient(135deg, #f0f4ff 0%, #f8f5ff 100%);
      padding-left: 16px;

      &::before {
        transform: scaleY(1);
      }
    }

    &.selected {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      font-weight: 600;

      &::before {
        display: none;
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  /* Toggle button */
  .react-dropdown-select-toggle {
    border-radius: 0 8px 8px 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    transition: all 0.3s ease;
    padding: 4px 12px;
    border: none;

    &:hover {
      opacity: 0.9;
    }
  }
`;

const mapStateToProps = (state) => {
    return {
        propp: state.sceneCardReducers,
        fetching: state.sceneCardReducers.fetching,
        isFetching: state.sceneCardReducers.fetching.filter,
        sites: state.sceneCardReducers.sites,
        movies: state.sceneCardReducers.movies,
        models: state.sceneCardReducers.models,
        studio: state.sceneCardReducers.studio,
        tags: state.sceneCardReducers.tags,
        openFilter: state.sceneCardReducers.openFilter,
        scenes: state.sceneCardReducers.sceneFilters
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setOpenFilter: (val) => dispatch(sceneCardActions.setOpenFilter(val)),
        setSceneFilter: (param, val) => dispatch(sceneCardActions.setSceneFilter(param, val)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterScene);